import { render, staticRenderFns } from "./GlobalUMRStatusToggle.vue?vue&type=template&id=1e914500&scoped=true"
import script from "./GlobalUMRStatusToggle.vue?vue&type=script&lang=js"
export * from "./GlobalUMRStatusToggle.vue?vue&type=script&lang=js"
import style0 from "./GlobalUMRStatusToggle.vue?vue&type=style&index=0&id=1e914500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e914500",
  null
  
)

export default component.exports